module.exports = __webpack_public_path__ + "static/media/facebook.56e61ca6.svg";